import React, { useState, useEffect } from 'react';
import { Container, Col, Row, Modal, Button, Card } from 'react-bootstrap';
import styles from './exportCSVModal.module.scss';
import { CustomCheckBox } from '../../../shared/customCheckBox'
import { CustomTextField } from '../../../shared/customTextField';
import { CustomButton } from '../../../shared/customButton';

import { CSVLink } from "react-csv";

const CSVModal = (props) => {


    //states from temporory column names and real cloumn names
    let [colums, setColums] = useState([]);

    let [showExportError, setShowExportError] = useState(false);
    let [exportErrorMsg, setExportErrorMsg] = useState('');

    //states to set csv data and topics
    let [csvDataRows, setCsvDataRows] = useState([]);

    //set CSV document data
    const csvData = csvDataRows;


    //prepare temporory coloumn names and original coloumn names
    const prepareColmns = async () => {
        let tempColumns = [];
        let realColumns = [];
        for (let index = 0; index < props.exportDetails.columns.length; index++) {
            let tempColumn = {
                is_enabled: true,
                label: props.exportDetails.columns[index].label,
                value: props.exportDetails.columns[index].value,
                download_column_name:props.exportDetails.columns[index].value
            };

            let tempRealColumn = {
                value: props.exportDetails.columns[index].value
            }
            tempColumns.push(tempColumn);
            realColumns.push(tempRealColumn);
        }

        //set arrays to states
        setColums(tempColumns);
    };

    //set checkbox value
    const enableDisableAttribute = (index) => {

        let columnArray = [...colums];
        for (let i = 0; i < columnArray.length; i++) {

            //condition to check for loop i value and index
            if (i == index) {
                columnArray[i].is_enabled = !columnArray[i].is_enabled;
            }
        }
        setColums(columnArray);
    };



    //set text value
    const changeDowloadColumnName = (value, index) => {

        let col_Array = [...colums];
        for (let i = 0; i < col_Array.length; i++) {
            if (i == index) {
                col_Array[i].download_column_name = value;
            }
        }
        setColums(col_Array);
    };

    //prepare csv document 
    const setCSVdocument = () => {

        let temp_csv_data_rows =[];

        let column_headers = [];//array to set column heaader values
        let original_col_names = [];// original,selected column name array

        for (let i = 0; i < colums.length; i++) {
            if (colums[i].is_enabled == true) {
                original_col_names.push(colums[i].value)
                column_headers.push(colums[i].download_column_name);
            }
        }

        if(column_headers.length>0){
            temp_csv_data_rows.push(column_headers); // add column names

            for (let i = 0; i < props.exportDetails.row_data.length; i++) {
                let dataRow = [];
                for (let j = 0; j < original_col_names.length; j++) {
                    dataRow.push(String(props.exportDetails.row_data[i][original_col_names[j]]))
                }
                temp_csv_data_rows.push(dataRow) // add a data row
            }
            setCsvDataRows(temp_csv_data_rows); // set the final data to download
        }
        else{
            setShowExportError(true);
            setExportErrorMsg('Nothing to download')
        }

        
    }


    useEffect(() => {
        prepareColmns();
    }, [])


    return (

        <div>
        <Modal
            show={props.show}
            onHide={props.handleClose}
            backdrop="static"
            keyboard={false}
            centered
            size="md"
        >
            <Modal.Body>
                <div className={styles.modalCancelBtnDiv}>
                    <Button className={styles.modalCancelBtn} onClick={props.handleClose}>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.5 4.5L4.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M4.5 4.5L13.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Button>
                </div>
                <div className={styles.modalHeaderDiv}>
                    <h2 className={styles.modalHeader}>CSV Export - {props.Title}</h2>
                    <hr></hr>

                </div>

                <Container>
                    <Row><Col>


                        <div className='ps-3 pe-3'>
                            <div className={styles.subTopic}>
                                Available attributes
                            </div>


                            {colums.map((item, index) =>  (

                                    <Row className=''>
                                        <Col lg={2}>

                                            <CustomCheckBox
                                                id={`item.${index}.is_enabled`}
                                                controlId={`item.${index}.is_enabled`}
                                                name={`item.${index}.is_enabled`}
                                                handleOnChange={() => enableDisableAttribute(index)}
                                                type="defaultCheckBox"
                                                value={item.is_enabled}
                                                ischecked={item.is_enabled}

                                            /></Col>
                                        <Col lg={4}>
                                            <p className={styles.cardTopics}>{item.label}</p>
                                        </Col>
                                        <Col>
                                            <CustomTextField
                                                //label="Stage Name"
                                                name={`item.${index}.value`}
                                                classLabel="defaultLabel"
                                                controlId={`item.${index}.value`}
                                                type="text"
                                                disabled={item.is_enabled ? false : true}
                                                value={item.download_column_name}
                                                classType="defaultTextBox"
                                                handleOnChange={(e) => changeDowloadColumnName(e.target.value, index)}
                                            />
                                        </Col>
                                    </Row>
                                )
                            )}
                        </div>
                        <Row>
                            <Col className='ms-5'>
                            {showExportError && <p className={styles.errorMsg}>{exportErrorMsg}</p>}
                            </Col>
                        </Row>
                        
                        <Row className={styles.btnRow}>


                            <Col >
                                <div className={styles.disconnectButton} >
                                    <CSVLink className={styles.linkButton}  data={csvData} filename={props.filename} onClick={() => setCSVdocument()}>

                                        <CustomButton
                                            type="primaryBtn"
                                            label="Export"
                                            buttonType="submit"
                                        />
                                    </CSVLink>

                                </div>
                            </Col>
                            <Col >
                                <div className={styles.disconnectButton} >
                                    <CustomButton
                                        type="defaultBtn"
                                        label="Cancel"
                                        buttonType="button"
                                        handleClick={props.handleClose}
                                    />
                                </div>
                            </Col>

                        </Row>
                    </Col>
                    </Row>
                </Container>
            </Modal.Body >
        </Modal>



        </div >
    )
}



export default CSVModal
